import React from 'react';
import { formatDate } from '../../../services/primitives/date-utils';
import { formatCurrency } from '../utils/statement-format.utils';
import { StatementDataTableColumn } from './statement-data-table';
import type { ServicesTableRow } from '../statement-details.types';
import {
    StatementAmount,
    StatementCodeBadge,
    StatementDxBadge,
    StatementDxList,
    StatementMutedText as StatementMuted,
    StatementPrimaryText as StatementPrimary,
    StatementSecondaryText as StatementSecondary,
} from './statement-ui';

export const createServicesTableColumns = (): StatementDataTableColumn<ServicesTableRow>[] => [
    {
        id: 'cpt',
        header: 'CPT',
        width: 90,
        render: row =>
            row.procedure ? (
                <StatementCodeBadge>{row.procedure}</StatementCodeBadge>
            ) : (
                <StatementMuted>—</StatementMuted>
            ),
    },
    {
        id: 'service',
        header: 'Service',
        width: 280,
        render: row => (
            <>
                <StatementPrimary>{row.description || '—'}</StatementPrimary>
                {row.claimId && <StatementSecondary>Claim #{row.claimId}</StatementSecondary>}
            </>
        ),
    },
    {
        id: 'dx',
        header: 'Diagnosis codes',
        width: 200,
        render: row =>
            row.diagnosisCodes.length > 0 ? (
                <StatementDxList>
                    {row.diagnosisCodes.map(code => (
                        <StatementDxBadge key={code}>{code}</StatementDxBadge>
                    ))}
                </StatementDxList>
            ) : (
                <StatementMuted>—</StatementMuted>
            ),
    },
    {
        id: 'date',
        header: 'Date',
        width: 120,
        render: row => (
            <StatementMuted>{row.date ? formatDate(row.date, 'MMM dd, yyyy') : '—'}</StatementMuted>
        ),
    },
    {
        id: 'charge',
        header: 'Charge',
        width: 110,
        render: row => (
            <StatementAmount tone="strong">
                {row.charge != null ? formatCurrency(String(row.charge)) : '—'}
            </StatementAmount>
        ),
    },
];
